import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/shell/Shell";
import * as React from 'react';
export default {
  Content,
  React
};